<section class="layout-success">
  <picture>
    <source [media]="mdScreenSize" [srcset]="desktopBackgroundImage" />
    <img class="layout-success__image" [src]="mobileBackgroundImage" alt="" />
  </picture>

  <div class="container">
    <div class="layout-success__container">
      <!-- Header -->
      <header class="layout-success__header">
        <!-- Logo Image -->
        <app-logo class="layout-success__logo" [name]="logo"></app-logo>

        <!-- Icon -->
        <vtmn-play-icon
          class="layout-success__icon"
          [name]="icon"
        ></vtmn-play-icon>

        <!-- Title -->
        <h1 class="layout-success__title title-1">{{ title }}</h1>
      </header>

      <div class="layout-success__content">
        <!-- Default slot -->
        <ng-content></ng-content>
      </div>

      <!-- Footer slot -->
      <footer class="layout-success__footer">
        <ng-content select="[footer]"></ng-content>
      </footer>
    </div>
  </div>
</section>
